<template>
  <div class="container">
    <div class="bg-white p-4 mt-5 rounded">
      <h1 class="text-center">
        {{ $t("registration.heading") }}
      </h1>
      <hr>
      <RegistrationForm></RegistrationForm>
    </div>
  </div>
</template>

<script>
import RegistrationForm from '../components/registration-form'

export default {
    name: 'Registration',
    components: {
        RegistrationForm,
    },
}
</script>
